import { render, staticRenderFns } from "./SideChat.vue?vue&type=template&id=7a30b074&"
import script from "./SideChat.vue?vue&type=script&lang=js&"
export * from "./SideChat.vue?vue&type=script&lang=js&"
import style0 from "./SideChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports